const LIST_COMMON = "/api/commons";
const LIST_QUANTITY_REQUEST = "/api/get-count-request";
const LIST_EMPLOYEE = "/api/employees";
const SHOW_EMPLOYEE = "/api/employees";
const DELETE_EMPLOYEE = "/api/employees";
const CREATE_EMPLOYEE = "/api/employees";
const UPDATE_EMPLOYEE = "/api/employees";
const GET_EMPLOYEE = "/api/employees";
const GET_INFORMATION_EMPLOYEE = "/api/employees";
const LIST_CUSTOMER = "/api/common/customers";
const RESIGNATION = "/api/employees/resignation";
const CHART_INFORMATION = "/api/charts";
const LIST_POSITION = "/api/common/positions";
const LIST_EMPLOYEE_TYPE = "/api/common/employee-type";

const LOGIN = "/api/login";
const REFRESH_TOKEN = "/api/refresh-token";
const ACCOUNT = "/api/account";
const CHANGE_PASSWORD = "/api/change-password";
const LIST_PROJECT = "/api/projects";

const GET_PROJECTS_EMPLOYEES_OVER_TIME =
  "/api/overtime-requests/get-project-employee";
const GET_APPROVAL_PERSON = "/api/overtime-requests/get-approval-person";
const SHOW_OVER_TIME_REQUEST_APPROVAL = "/api/overtime-requests/show-approval";
const CREATE_OVER_TIME = "/api/overtime-requests";
const UPDATE_OVER_TIME = "/api/overtime-requests";
const GET_INFO_OVER_TIME = "/api/overtime-requests";
const APPROVE_OVER_TIME = "/api/overtime-requests/approve";
const APPROVE_LIST_OVER_TIME = "/api/overtime-requests/approve/list-request";

// Time sheet
const TIME_SHEET = "/api/timesheets";
const USER_TIME_SHEET = "/api/user/timesheets";
const USER_CHECK_IN = "/api/user/timesheets/checkin";
const USER_CHECK_OUT = "/api/user/timesheets/checkout";
const TIME_SHEET_REQUEST = "/api/timesheets/requests";
const IMPORT_TIMESHEET = "/api/timesheets/import";
const TIME_SHEET_TODAY = "/api/user/timesheets/today";
const TIMESHEET_DASHBOARD = "/api/timesheet-dashboard";
const TIMESHEET_TOTAL_REQUEST = "/api/timesheet-dashboard/total-requests";
const COMPENSATION_TIMESHEET = "/api/compensation-timesheet";
const SUBMIT_TIMESHEET = "/api/user/timesheets/submit-timesheets";
const UNSUBMIT_TIMESHEET = "/api/user/timesheets/unsubmit-timesheets";

const GET_COMMON_PROJECT = "/api/projects/create";
const CREATE_PROJECT = "/api/projects";
const GET_DETAIL_PROJECT = "/api/projects";
const UPDATE_PROJECT = "/api/projects";

const LIST_OVERTIME_REQUEST = "/api/overtime-requests";
const SHOW_OVERTIME_REQUEST = "/api/overtime-requests";
const DELETE_OVER_TIME_REQUEST = "/api/overtime-requests";
const LIST_OVERTIME_REQUEST_APPROVAL = "/api/overtime-requests/approval";
const SAVE_TOKEN = "/api/notifications/save-device-token";
const REMOVE_TOKEN = "/api/notifications/remove-device-token";
const LIST_NOTIFICATION = "/api/notifications";
const UPDATE_STATUS_NOTIFICATION =
  "/api/notifications/update-status-notification";

const CREATE_ADDITIONAL_TIMESHEET = "/api/additional-timesheet/create";
const REGISTER_ADDITIONAL_TIMESHEET = "/api/additional-timesheet";
const EDIT_ADDITIONAL_TIMESHEET = "/api/additional-timesheet";
const UPDATE_ADDITIONAL_TIMESHEET = "/api/additional-timesheet";
const SHOW_APPROVAL_ADDITIONAL_TIMESHEET =
  "/api/additional-timesheet/show-approval";
const APPROVAL_ADDITIONAL_TIMESHEET = "/api/additional-timesheet/approval";
const LIST_ADDITIONAL_TIMESHEET = "/api/additional-timesheet";
const DELETE_ADDITIONAL_TIMESHEET = "/api/additional-timesheet";
const SHOW_ADDITIONAL_TIMESHEET = "/api/additional-timesheet";
const APPROVE_LIST_ADDITIONAL_TIMESHEET =
  "/api/additional-timesheet/approve/list-request";

const LIST_SABBATICAL_LEAVE_REQUEST = "/api/sabbatical-leave-request";
const LIST_SABBATICAL_LEAVE_APPROVAL = "/api/sabbatical-leave-request/approval";
const SHOW_SABBATICAL_LEAVE_REQUEST = "/api/sabbatical-leave-request";
const DELETE_SABBATICAL_LEAVE_REQUEST = "/api/sabbatical-leave-request";
const SABBATICAL_DAYS_OFF = "/api/sabbatical-days-off";
const SABBATICAL_DASHBOARD_DAYS_OFF = "/api/sabbatical-days-off/get-count";
const SABBATICAL_LOG = "/api/sabbatical-log/sabbatical-log-all";
const SABBATICAL_LEAVE = "/api/sabbatical-log/sabbatical-leave";

const GET_DATA_COMMON = "/api/sabbatical-leave-request/get-commons";
const CREATE_SABBATICAL = "/api/sabbatical-leave-request";
const GET_INFO_SABBATICAL = "/api/sabbatical-leave-request";
const UPDATE_SABBATICAL = "/api/sabbatical-leave-request";
const SHOW_SABBATICAL_REQUEST_APPROVAL =
  "/api/sabbatical-leave-request/show-approval";
const APPROVE_SABBATICAL = "/api/sabbatical-leave-request/approve";
const GET_CALCULATE_DAY_LEAVE =
  "/api/sabbatical-leave-request/get-calculate-day-leave";
const APPROVE_LIST_SABBATICAL =
  "/api/sabbatical-leave-request/approve/list-request";

const LIST_SKILL_SHEET = "/api/skill-sheet";
const CREATE_SKILL_SHEET = "/api/skill-sheet";
const LIST_SEAT_EMPLOYEE = "/api/entity/get-location";
const LIST_SHORT_LEAVE_REQUEST = "/api/short-leave-requests";
const LIST_SHORT_LEAVE_REQUEST_ASSIGN = "/api/short-leave-requests/assign";
const CREATE_SHORT_LEAVE_REQUEST = "/api/short-leave-requests";
const UPDATE_SHORT_LEAVE_REQUEST = "/api/short-leave-requests/{id}";
const GET_REQUEST_ASSIGNABLE_POSITIONS =
  "/api/get-request-assignable-positions";

const TECHNOLOGIES = "/api/common/technologies";

// logwork
const LOGWORK = {
  PROJECTS: "/api/logwork/projects",
  MEMBERS: "/api/logwork/members",
  TIMELINE: "/api/logwork/timeline",
  TIMELINE_ITEMS: "/api/logwork/timeline/{id}/items",
  SUBMIT: "/api/logwork/submit",
  SUBMIT_SUMMARY: "/api/logwork/submit/summary",
  CREATE: "/api/logwork",
  UPDATE: "/api/logwork/{id}/update",
  DETAIL: "/api/logwork/{id}/detail",
  APPROVAL: "/api/logwork/approval",
  EXPORT: "/api/logwork/excel",
  ATTRIBUTES: "/api/logwork/attributes"
};
const BACKLOG = {
  ISSUE: "/api/backlog/issue"
};

// check point
const CHECKPOINT = {
  REVIEW_PROCESS: "/api/checkpoint/review-process",
  REVIEW_LIST: "/api/checkpoint/review-list",
  LEFT_MENU: "/api/checkpoint/menu",
  REVIEW_FORM: "/api/checkpoint/review-form",
  REVIEW_SUBMIT: "/api/checkpoint/review-submit",
  RESULT_MEMBER: "/api/checkpoint/result",
  EXPORT_CHECK_POINT_LIST: "/api/checkpoint/export-check-point-list"
};
//skill
const GET_LIST_SKILL = "/api/skill/all_skills";
const GET_EMPLOYEE_SKILL = "/api/skill/employee_skills";
const POST_EMPLOYEE_SKILL = "/api/skill/save_updated_skills";

//summer trip vote
const SUMMER_TRIP_VOTE = {
  API_VOTE: "/api/company-trip-vote/",
  START: "/start",
  END: "/end",
  GET_STATUS_VOTE: "/get-status-vote",
  GET_VOTES: "/vote",
  GET_TIMEOUT: "timeout",
  RESET: "/reset"
};
// check point
const NEWS = {
  NEW_POST: "/api/news",
  NEW_LIST: "/api/news",
  NEW_EDIT: "/api/news/show-news",
  NEW_UPDATE: "/api/news",
  NEW_DELETE: "/api/news"
};

// project management
const PROJECT_MANAGEMENT = {
  PROJECT_DETAIL: "/api/projects",
  EFFORT: "/api/projects",
  UPDATE_PROJECT_DETAIL: "/api/projects/:id/update",
  REVIEWS: "/api/projects/:id/overview",
  CREATE_CONTRACT_HISTORY: "/api/contract-history/create",
  UPDATE_CONTRACT_HISTORY: "/api/contract-history/update",
  CONTRACT_HISTORY: "/api/contract-history/:id",
  EFFORT_EMPLOYEE_PROJECT: "/api/projects/:id/effort-employees",
  EFFORT_EMPLOYEE_PROJECT_DETAIL: "/api/projects/:id/effort-employees/detail",
  UPDATE_PROJECT_EMPLOYEE: "/api/projects/:id/project-employee"
};
// remote
const REMOTE_API = "/api/remote";
const REMOTE_MANAGEMENT = {
  REMOTE_LIST: REMOTE_API,
  REMOTE_APPROVAL_LIST: `${REMOTE_API}/approval`,
  GET_USER_REMOTE_INFO: "/api/remote/create",
  CREATE_REMOTE_REQUEST: "/api/remote",
  DELETE_REMOTE_REQUEST: `${REMOTE_API}/:id`,
  GET_REMOTE_REQUEST_INFO: "/api/remote/:id/edit",
  EDIT_REMOTE_REQUEST_INFO: "/api/remote/:id",
  GET_APPROVAL_REMOTE_REQUEST_INFO: "/api/remote/:id/show-approval",
  APPROVE_REMOTE_REQUEST: "/api/remote/approve/:id"
};
export default {
  LIST_COMMON,
  LIST_QUANTITY_REQUEST,
  LIST_EMPLOYEE,
  SHOW_EMPLOYEE,
  DELETE_EMPLOYEE,
  CREATE_EMPLOYEE,
  UPDATE_EMPLOYEE,
  GET_EMPLOYEE,
  GET_INFORMATION_EMPLOYEE,
  LIST_CUSTOMER,
  RESIGNATION,
  CHART_INFORMATION,
  LOGIN,
  REFRESH_TOKEN,
  ACCOUNT,
  CHANGE_PASSWORD,
  LIST_PROJECT,
  GET_COMMON_PROJECT,
  CREATE_PROJECT,
  GET_DETAIL_PROJECT,
  UPDATE_PROJECT,
  TIME_SHEET,
  USER_TIME_SHEET,
  USER_CHECK_IN,
  USER_CHECK_OUT,
  TIME_SHEET_REQUEST,
  IMPORT_TIMESHEET,
  TIME_SHEET_TODAY,
  TIMESHEET_DASHBOARD,
  TIMESHEET_TOTAL_REQUEST,
  COMPENSATION_TIMESHEET,
  SUBMIT_TIMESHEET,
  UNSUBMIT_TIMESHEET,
  CREATE_OVER_TIME,
  UPDATE_OVER_TIME,
  GET_INFO_OVER_TIME,
  GET_PROJECTS_EMPLOYEES_OVER_TIME,
  APPROVE_OVER_TIME,
  SHOW_OVER_TIME_REQUEST_APPROVAL,
  SHOW_OVERTIME_REQUEST,
  DELETE_OVER_TIME_REQUEST,
  LIST_OVERTIME_REQUEST_APPROVAL,
  LIST_OVERTIME_REQUEST,
  SAVE_TOKEN,
  REMOVE_TOKEN,
  LIST_NOTIFICATION,
  UPDATE_STATUS_NOTIFICATION,
  CREATE_ADDITIONAL_TIMESHEET,
  REGISTER_ADDITIONAL_TIMESHEET,
  EDIT_ADDITIONAL_TIMESHEET,
  UPDATE_ADDITIONAL_TIMESHEET,
  SHOW_APPROVAL_ADDITIONAL_TIMESHEET,
  APPROVAL_ADDITIONAL_TIMESHEET,
  LIST_SABBATICAL_LEAVE_REQUEST,
  LIST_SABBATICAL_LEAVE_APPROVAL,
  SHOW_SABBATICAL_LEAVE_REQUEST,
  DELETE_SABBATICAL_LEAVE_REQUEST,
  LIST_ADDITIONAL_TIMESHEET,
  DELETE_ADDITIONAL_TIMESHEET,
  SHOW_ADDITIONAL_TIMESHEET,
  GET_DATA_COMMON,
  CREATE_SABBATICAL,
  GET_INFO_SABBATICAL,
  UPDATE_SABBATICAL,
  SHOW_SABBATICAL_REQUEST_APPROVAL,
  APPROVE_SABBATICAL,
  GET_CALCULATE_DAY_LEAVE,
  GET_APPROVAL_PERSON,
  LIST_SKILL_SHEET,
  CREATE_SKILL_SHEET,
  APPROVE_LIST_OVER_TIME,
  APPROVE_LIST_ADDITIONAL_TIMESHEET,
  APPROVE_LIST_SABBATICAL,
  LIST_SEAT_EMPLOYEE,
  CHECKPOINT,
  GET_LIST_SKILL,
  GET_EMPLOYEE_SKILL,
  POST_EMPLOYEE_SKILL,
  SABBATICAL_DAYS_OFF,
  SABBATICAL_LOG,
  SABBATICAL_LEAVE,
  SABBATICAL_DASHBOARD_DAYS_OFF,
  NEWS,
  PROJECT_MANAGEMENT,
  LIST_POSITION,
  LIST_EMPLOYEE_TYPE,
  TECHNOLOGIES,
  SUMMER_TRIP_VOTE,
  REMOTE_MANAGEMENT,
  LIST_SHORT_LEAVE_REQUEST,
  LIST_SHORT_LEAVE_REQUEST_ASSIGN,
  CREATE_SHORT_LEAVE_REQUEST,
  UPDATE_SHORT_LEAVE_REQUEST,
  GET_REQUEST_ASSIGNABLE_POSITIONS,
  LOGWORK,
  BACKLOG
};
